import isUUID from './isUUID'

const isGuid = isUUID

export default isGuid
